import _ from 'lodash';
import appConfig from '@nerdwallet/app-config';
import createOfferSdk from '@nerdwallet/nw-api-sdk/offers';
import createMarketplaceSdk from '@nerdwallet/nw-api-sdk/marketplace';
import initNwApiSdk from '@nerdwallet/nw-api-sdk';
import { Experiment } from './experiment-list';

const nwApiSDK = initNwApiSdk({
  applicationID: 'nerdWallet web',
  clientID: appConfig.CLIENT_ID || 'landing-page-client',
  cookieDomain: appConfig.COOKIE_DOMAIN,
  identityBaseUrl: appConfig.IDENTITY_BASE_URL,
  transunionBaseUrl: appConfig.TRANSUNION_BASE_URL,
  abUrl: appConfig.AB_BASE_URL,
  abExperimentList: _.map(Experiment, (exp) => exp.id),
  xhrTimeout: 10000,
  userDataPlatformBaseUrl: appConfig.SERVICE_URLS.USER_DATA,
  shimUDP: appConfig?.IDENTITY?.SDK?.UDP_PROFILE_SHIM?.ENABLED,
  UDPMemberProfilesList: appConfig?.IDENTITY?.SDK?.UDP_PROFILE_SHIM?.PROFILES,
  TUProfilesList: appConfig.TRANSUNION.DATA_API_PROFILES,
});

export const marketplaceSDK = createMarketplaceSdk({
  ServiceSDK: nwApiSDK.ServiceSDK,
  clientID: appConfig.CLIENT_ID,
  marketplaceBaseUrl: appConfig.MARKETPLACE_API_BASE_URL,
  wpApiBaseUrl: appConfig.API.BASE_URLS.WP_API,
});

export const OfferSDK = createOfferSdk({
  ServiceSDK: nwApiSDK.ServiceSDK,
  clientID: appConfig.CLIENT_ID,
  offerBaseUrl: appConfig.MARKETPLACE_API_BASE_URL,
  version: 1,
});

export default nwApiSDK;
